import React from "react";

export const SEO = ({
  title,
  description,
  pathname,
  children,
  image,
  canonical,
  page,
  totalPages,
  noIndex,
}) => {
  const seo = {
    title: title,
    description,
    image: image || "https://media.salvex.com/emails/defaultimage2x.png",
    url: pathname,
    twitterUsername: "@SalvexGroup",
  };

  return (
    <>
      <title>{seo.title}</title>{" "}
      {(process.env.GATSBY_APP_MODE === "dev" || noIndex) && <meta name="robots" content="noindex,nofollow" />}
      <meta name="description" content={seo.description} />
      <meta name="image" content={seo.image} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={seo.title} />
      <meta name="twitter:description" content={seo.description} />
      <meta name="twitter:image" content={seo.image} />
      <meta name="twitter:creator" content={seo.twitterUsername} />
      {canonical && <link rel="canonical" href={canonical} />}
      {/* Open Graph */}
      <meta property="og:url" content={seo.url} />
      <meta property="og:type" content="website" />
      <meta property="og:title" content={seo.title} />
      <meta property="og:site_name" content={seo.title} />
      <meta property="og:description" content={seo.description} />
      <meta property="og:image" content={seo.image} />
      {!!(page + 1) && totalPages && page + 1 > 1 && page <= totalPages && (
        <link
          rel="prev"
          href={`${
            process.env.GATSBY_APP_MODE == "dev"
              ? "https://www.newdev.salvex.com"
              : "https://www.salvex.com"
          }${pathname}?page=${page}`}
        />
      )}
      {!!(page + 1) && totalPages && page + 1 < totalPages && (
        <link
          rel="next"
          href={`${
            process.env.GATSBY_APP_MODE == "dev"
              ? "https://www.newdev.salvex.com"
              : "https://www.salvex.com"
          }${pathname}?page=${page + 2}`}
        />
      )}
      {children}
    </>
  );
};
